import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, SparklesIcon, BrainIcon, PiggyBankIcon } from 'lucide-react';
import { SalesButton } from '../ui/SalesButton';
export function BenefitsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const benefits = [{
    icon: CheckIcon,
    title: 'Deducir con Confianza',
    description: 'Sabrás exactamente qué recibos guardar y por qué. Sin dudas, sin miedos.'
  }, {
    icon: BrainIcon,
    title: 'Eliminar la Ansiedad',
    description: 'Dormirás tranquilo sabiendo que cada dólar que descuentas está respaldado por la ley.'
  }, {
    icon: PiggyBankIcon,
    title: 'Ahorro Inmediato',
    description: 'Esta guía cuesta menos que una cena fuera, pero puede devolverte miles de dólares.'
  }];
  return <section ref={ref} className="bg-gradient-to-b from-white to-gray-50 py-20 lg:py-28" data-id="element-1">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-3">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/10 text-[#c9a227] rounded-full text-sm font-semibold mb-6" data-id="element-4">
            <SparklesIcon className="w-4 h-4" data-id="element-5" />
            Lo Que Vas a Lograr
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a2744] leading-tight" data-id="element-6">
            Transforma Tu Relación <br className="hidden sm:block" data-id="element-7" />
            <span className="text-[#c9a227]" data-id="element-8">Con Los Impuestos</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-9">
          {benefits.map((benefit, index) => <motion.div key={benefit.title} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2 + index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100" data-id="element-10">
              <div className="w-14 h-14 bg-[#c9a227]/10 rounded-xl flex items-center justify-center mb-6" data-id="element-11">
                <benefit.icon className="w-7 h-7 text-[#c9a227]" data-id="element-12" />
              </div>
              <h3 className="text-xl font-bold text-[#1a2744] mb-3" data-id="element-13">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-14">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="bg-[#1a2744] rounded-3xl p-8 lg:p-12" data-id="element-15">
          <div className="grid lg:grid-cols-2 gap-8 items-center" data-id="element-16">
            <div data-id="element-17">
              <h3 className="text-2xl lg:text-3xl font-bold text-white mb-4" data-id="element-18">
                🛡️ El Escudo 1099 Incluye:
              </h3>
              <ul className="space-y-4" data-id="element-19">
                <li className="flex items-start gap-3" data-id="element-20">
                  <div className="w-6 h-6 bg-[#c9a227] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-21">
                    <CheckIcon className="w-4 h-4 text-[#1a2744]" data-id="element-22" />
                  </div>
                  <span className="text-gray-300" data-id="element-23">
                    <strong className="text-white" data-id="element-24">+60 páginas</strong> de
                    estrategias fiscales en español claro
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-25">
                  <div className="w-6 h-6 bg-[#c9a227] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-26">
                    <CheckIcon className="w-4 h-4 text-[#1a2744]" data-id="element-27" />
                  </div>
                  <span className="text-gray-300" data-id="element-28">
                    <strong className="text-white" data-id="element-29">Lista maestra</strong> de
                    deducciones para 1099
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-30">
                  <div className="w-6 h-6 bg-[#c9a227] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-31">
                    <CheckIcon className="w-4 h-4 text-[#1a2744]" data-id="element-32" />
                  </div>
                  <span className="text-gray-300" data-id="element-33">
                    <strong className="text-white" data-id="element-34">Plantillas</strong> de
                    rastreo de gastos y millaje
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-35">
                  <div className="w-6 h-6 bg-[#c9a227] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-36">
                    <CheckIcon className="w-4 h-4 text-[#1a2744]" data-id="element-37" />
                  </div>
                  <span className="text-gray-300" data-id="element-38">
                    <strong className="text-white" data-id="element-39">Guía específica</strong> para
                    Uber, DoorDash, construcción y más
                  </span>
                </li>
              </ul>
            </div>
            <div className="text-center lg:text-right" data-id="element-40">
              <div className="inline-block bg-[#243352] rounded-2xl p-6 mb-6" data-id="element-41">
                <p className="text-gray-400 text-sm mb-1" data-id="element-42">
                  Precio especial de lanzamiento
                </p>
                <div className="flex items-baseline justify-center lg:justify-end gap-2" data-id="element-43">
                  <span className="text-gray-500 line-through text-2xl" data-id="element-44">
                    $27
                  </span>
                  <span className="text-5xl font-bold text-[#c9a227]" data-id="element-45">
                    $6.39
                  </span>
                </div>
                <p className="text-green-400 text-sm mt-2" data-id="element-46">
                  ¡Ahorras $20.61 hoy!
                </p>
              </div>
              <SalesButton size="large" className="w-full lg:w-auto" data-id="element-47">
                QUIERO MI ESCUDO AHORA
              </SalesButton>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}